var exports = {
  "nM": "CrosspostPublishNudge.module__row___UWRXd2",
  "Io": "CrosspostPublishNudge.module__pill___UWRXd2",
  "Kk": "CrosspostPublishNudge.module__icon___UWRXd2",
  "Pf": "CrosspostPublishNudge.module__label___UWRXd2",
  "_4": "CrosspostPublishNudge.module__publishButton___UWRXd2",
  "r": "CrosspostPublishNudge.module__dismissButton___UWRXd2",
  "EL": "CrosspostPublishNudge.module__hideForeverButton___UWRXd2",
  "MW": "CrosspostPublishNudge.module__dismissIcon___UWRXd2",
};

module.exports = exports;
